import { getErrorMsgAndCode, validateInput } from "./FrontendHelpers";
import api from "./axios";

const checkInput = (ID, Name) => {
  return validateInput([
    {
      Name: "ID",
      Value: ID,
      Type: "unitID",
      MaxLengthType: "id",
      MinLength: 1,
    },
    {
      Name: "Name",
      Value: Name,
      Type: "string",
      MinLength: 1,
      MaxLengthType: "name",
    },
  ]);
};

export async function GetUnits() {
  try {
    const response = await api.get("/getUnits");
    const data = response.data;
    return [data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetUnitData(argument, bywhat = "UnitID") {
  try {
    const data = {
      Argument: argument,
      byWhat: bywhat,
    };
    const response = await api.post("/getUnitInfo", data);

    const result = response.data;
    return [result[0], null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CreateUnit(ID, Name) {
  try {
    const errorObj = checkInput(ID, Name);
    if (errorObj.errCode !== 0) return [null, errorObj];
    const data = {
      ID: ID,
      Name: Name,
    };

    const response = await api.post("/createUnit", data);

    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetNextUnitID() {
  try {
    const response = await api.get("/getNextUnitID");
    const data = response.data;
    return [data.nextID, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function EditUnit(ID, NewID, Name) {
  try {
    const errorObj = checkInput(NewID, Name);
    if (errorObj.errCode !== 0) return [null, errorObj];

    const data = {
      ID: NewID,
      CurrentID: ID,
      Name: Name,
    };
    const response = await api.post("/editUnit", data);

    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function DeleteUnit(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/deleteUnit", data);
    const result = response.data;
    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CheckForUnit(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/checkForUnit", data);
    const result = response.data;
    if (result[0]) {
      return [true, null];
    }

    return [false, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
